const Data = [
    {
        "name": "Saurabh Chavan",
        "position": "Finance Head",
        "imageUrl": "/assets/images/members/Heads24/SaurabhChavan.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100087932744081&mibextid=JRoKGi",
        "linkedinLink": "https://www.linkedin.com/in/saurabh-chavan-961819251?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        "email": "saurabh.chavan@gyws.org"
    },
    {
        "name": "Satvik Jaiswal",
        "position": "Finance Head",
        "imageUrl": "/assets/images/members/Heads24/SatvikJaiswal.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100089660656382&mibextid=rS40aB7S9Ucbxw6v",
        "linkedinLink": "https://www.linkedin.com/in/satvik-j",
        "email": "satvik.jaiswal@gyws.org"
    },
    {
        "name": "Aditya Singh Yadav",
        "position": "Finance Head",
        "imageUrl": "/assets/images/members/Heads24/AdityaYadav.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100087545650107",
        "linkedinLink": "https://www.linkedin.com/in/aditya-yadav-7ab715269/",
        "email": "aditya.yadav@gyws.org"
    }
]

export default Data;